module.exports = __webpack_public_path__ + "static/media/wrong2.3fcf44e4.jpg";